module.exports = __webpack_public_path__ + "static/media/yellowcat.acd0047a.png";